import React from "react";
import { useEffect, useState } from "react";
import { Container, Row, Col, Button, Modal } from "react-bootstrap";
import SearchableSelect from "../../Components/SearchableSelect";
import useApi from "../../Hooks/useApi";
import * as api from "../../api/getapi";
import * as postapi from "../../api/postapi";
import customloader from "../../assets/images/RollingLoader.gif";
import NoResult from "../../Components/NoResult";
import CustomizeTableview from "../../Components/TableViews/CustomizeTableview";
import PaginationBar from "../../Components/PaginationBar";
import PopUpModal from "../../Components/Modal";
import SearchInput from "../../Components/SearchInput";
import DeliveryPartnerModal from "./DeliveryPartnerModal";
function DeliveryPartners() {
  const [noOfPages, setNoOfPages] = useState(1);
  const [sizeOfPages, setSizeOfPages] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [count, setCount] = useState(0);
  const [toggle, refresh] = useState(false);
  const [orderBy, setOrderBy] = useState({ created_at: "DESC" });
  const [addPartnerModalShow, setAddPartnerModalShow] = useState(false);
  const [deliveryPartnersData, setDeliveryPartnersData] = useState([]);
  const [selectedPartner, setSelectedPartner] = useState({});
  const [editModal, setEditModal] = useState(false);
  const [search, setSearch] = useState("");
  const [deleteModal, setDeleteModal] = useState(false);

  const fetchDeliveryPartners = useApi(api.getDeliveryPartners);
  const deleteDeliveryPartner = useApi(postapi.deleteDeliveryPartner);

  const resetFilterHandle = () => {
    setSizeOfPages(10);
    setOrderBy({ created_at: "DESC" });
    setSearch("");
  };

  const handlePageSize = (e) => {
    setSizeOfPages(e.value);
  };

  const changePage = (page) => {
    setCurrentPage(page);
  };
  const fetchAllDeliveryPartners = async () => {
    const res = await fetchDeliveryPartners.request({
      size: sizeOfPages,
      page: currentPage,
      search: search,
      orderBy: orderBy,
    });
    const data = res?.data;
    if (data) {
      setDeliveryPartnersData(data?.data);
      setCount(data?.count?.no_of_items);
      if (data?.count?.no_of_pages === 0) {
        setNoOfPages(0);
      } else {
        setNoOfPages(data?.count.no_of_pages);
        if (currentPage > data?.count?.no_of_pages) {
          setCurrentPage(data?.count?.no_of_pages);
        }
      }
    } else {
      setDeliveryPartnersData([]);
    }
  };
  useEffect(() => {
    fetchAllDeliveryPartners();
  }, [currentPage, sizeOfPages, toggle, orderBy, search]);

  useEffect(() => {
    if (currentPage === 1) {
      refresh((prev) => !prev);
    } else {
      changePage(1);
    }
  }, []);
  const edit = (data) => {
    setEditModal(true);
    setSelectedPartner(data);
  };
  const closeModalAdd = () => {
    setAddPartnerModalShow(false);
  };
  const closeModalEdit = () => {
    setEditModal(false);
    setAddPartnerModalShow(false);
  };

  const remove = (data) => {
    setDeleteModal(true);
    setSelectedPartner(data);
  };

  const closeModalDelete = () => {
    setDeleteModal(false);
  };

  const searchHandle = (e) => {
    e.preventDefault();
    if (e.target.value === "") {
      setSearch("");
    } else {
      setSearch(e.target.value);
    }
    setCurrentPage(1);
  };
  const deletePartner = async () => {
    try {
      await deleteDeliveryPartner.request(selectedPartner);
      closeModalDelete();
      refresh((prev) => !prev);
    } catch (error) {
      console.log("Error deleting delivery partner:", error);
    }
  };
  return (
    <div>
      <div>
        <Container fluid>
          <Row className="">
            <Col xs="2" lg="3" xl="2" className="">
              <SearchInput value={search} searchlogo handleChange={searchHandle} />
            </Col>
            <Col xs="6" lg="2" className="">
              <SearchableSelect
                selectClassName={"bg-white"}
                placeholder={`Showing ${sizeOfPages}`}
                defaultValue={`Showing ${sizeOfPages}`}
                value={`Showing ${sizeOfPages}`}
                searchable={false}
                options={[
                  { value: "10", label: "10" },
                  { value: "20", label: "20" },
                  { value: "30", label: "30" },
                ]}
                handleChange={handlePageSize}
              />
            </Col>
            <Col>
              <Button className=" mx-3 " size="sm" type="submit" style={{ fontSize: "14px" }} onClick={() => setAddPartnerModalShow(true)}>
                <span className="d-flex ">Add Partner + </span>{" "}
              </Button>
            </Col>
          </Row>
          <>
            <div className="pt-2">
              <Button className="mt-3" size="sm" type="submit" style={{ fontSize: "14px" }} onClick={resetFilterHandle}>
                <span className="d-flex ">Reset Filters</span>{" "}
              </Button>
            </div>

            {fetchDeliveryPartners.isLoading ? (
              <div className="d-flex justify-content-center align-items-center" style={{ height: "70vh" }}>
                <img src={customloader} alt="customloader" width="100" height="100" />
              </div>
            ) : deliveryPartnersData.length === 0 ? (
              <NoResult />
            ) : (
              <Row style={{ marginBottom: "-3rem" }} className="mt-3">
                <CustomizeTableview data={deliveryPartnersData} columnNotShow={["id", "is_deleted"]} dateColumn={["created_at", "updated_at"]} sortColumn={["created_at", "updated_at", "name"]} orderBy={orderBy} setOrderBy={setOrderBy} edit={edit} cancel={remove} />
                <Row className="mt-5">
                  <Col className="d-none d-lg-block" md="6" lg="3">
                    <span className="text-secondary fs-6">{count} Result(s)</span>
                  </Col>
                  <Col xs="12" lg="6">
                    <PaginationBar noOfPages={noOfPages} currentPage={currentPage} changePage={changePage} />
                  </Col>
                  <Col className="d-md-none d-flex align-items-center mt-3" xs="6" lg="3">
                    <span className="text-secondary fs-6">{count} Result(s)</span>
                  </Col>
                  <Col xs="6" lg="3" className="text-end mt-3"></Col>
                </Row>
              </Row>
            )}
            <PopUpModal title="Add Delivery Partner" show={addPartnerModalShow} onHide={closeModalAdd}>
              <DeliveryPartnerModal toggle={refresh} close={closeModalAdd} deliveryPartnersData={selectedPartner} edit={false} />
            </PopUpModal>
            <PopUpModal title="Update Delivery Partner" show={editModal} onHide={closeModalEdit}>
              <DeliveryPartnerModal toggle={refresh} close={closeModalEdit} deliveryPartnersData={selectedPartner} edit={true} />
            </PopUpModal>
          </>
        </Container>
      </div>

      <Modal show={deleteModal} onHide={closeModalDelete} centered>
        <Modal.Header closeButton>
          <Modal.Title>Delete Delivery Partner</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete this delivery partner?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeModalDelete}>
            Cancel
          </Button>
          <Button variant="danger" onClick={deletePartner}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default DeliveryPartners;
